import React from 'react';


export default class Loader extends React.Component {

	_handleError() {
		if (this.props.error) {
			try {
				/* eslint-disable no-undef */
				Raven.captureException(new Error('Loader error', this.props.error));
				/* eslint-enable no-undef */
			} catch (e) {
				console.error(this.props.error);
				console.error(e);
			}
		}
	}

	componentDidMount() {
		this._handleError();
	}
	componentDidUpdate() {
		this._handleError();
	}

	render() {
		const props = this.props;
		if (props.error) {
			return (
				<div style={{padding: '2em'}} className='fade-in-pls loading-container'>
					<div style={{margin: 'auto', color: 'white'}}>
						<div className='loading-text'>
							<h2>Oh no something went wrong</h2>
							<p>
								Try going back, checking your internet connection is okay, and flailing your arms wildly.
							</p>
							<p>
								The website support Foxxo has been notified and will be dispatched <i>violently & immediately</i> to resolve this.
							</p>
						</div>
					</div>
				</div>
			);
		} else if (props.pastDelay) {
			return (
				<div style={{padding: '2em'}} className='fade-in-pls loading-container'>
					<div style={{margin: 'auto', width: '10em', color: 'white'}}><span className='loading-text'>Loading...</span><span className="cookie-spin"><span role="img" aria-label="Loading spinner">🍪</span></span></div>
				</div>
			);
		} else {
			return null;
		}
	}
}



// WEBPACK FOOTER //
// ./src/modules/Loader.js